module.exports = __webpack_public_path__ + "img/skearLogo2020LueurExterne-min.965ed524.png";